var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.env !== 'production')?_c('div',{staticClass:"bar",class:{
    'bar-qa': _vm.env.includes('qa'),
    'bar-development': _vm.env === 'development',
    'bar-staging': _vm.env === 'staging',
  }},[_c('span',{staticClass:"bar-text"},[_vm._v(_vm._s(_vm.envText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }